import { CDN_URL } from "@env";
import { NewGameTagTypes } from "./image-types/new-game-tag-types";

const NewGameTagAssets: NewGameTagTypes = {
  "img_0": CDN_URL + "/image-assets/animation-assets/new-game-tag/images/img_0.png",
  "img_1": CDN_URL + "/image-assets/animation-assets/new-game-tag/images/img_1.png",
};

export default NewGameTagAssets;
